import { Component, OnInit } from '@angular/core';
import { FieldConfig } from '@smartflip/data-models';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { FormService, RoiService } from '@smartflip/ui-utils';
import { repairDetailFields } from '@smartflip/data-field-configuration';

@Component({
  selector: 'app-repair-detail-costs',
  templateUrl: './repair-detail-costs.component.html',
  styleUrls: ['./repair-detail-costs.component.scss'],
  standalone: false,
})
export class RepairDetailCostsComponent implements OnInit {
  public fieldList: FieldConfig[];
  public repairDetailForm: UntypedFormGroup;
  public originalValue: Record<string, string | number>;

  constructor(
    public roi: RoiService,
    private frm: FormService,
    public modalController: ModalController,
  ) {}

  get total() {
    const details = this.repairDetailForm.get('details');

    if (details?.value.length > 0) {
      return details.value.reduce((total, item) => total + item.cost, 0);
    } else return 0;
  }

  public save() {
    const details = this.repairDetailForm.value;

    this.modalController.dismiss({ total: this.total, details });
  }

  cancel() {
    this.repairDetailForm.reset(this.originalValue);
    this.modalController.dismiss();
  }

  addCost() {
    const newCost = this.frm.createControl([
      {
        type: 'input',
        label: 'Name',
        inputType: 'text',
        name: 'name',
      },
      {
        type: 'input',
        label: 'Cost',
        inputType: 'text',
        name: 'cost',
      },
    ]);
    (this.repairDetailForm.get('details') as UntypedFormArray).push(newCost);
  }

  ngOnInit() {
    this.fieldList = repairDetailFields;
    this.repairDetailForm = this.roi.formGroups['repairdetail'];
    this.originalValue = this.repairDetailForm.value;
  }
}
